import { render, staticRenderFns } from "./BookingPrestaIssueDetail.vue?vue&type=template&id=cc6e9930&scoped=true"
import script from "./BookingPrestaIssueDetail.vue?vue&type=script&lang=js"
export * from "./BookingPrestaIssueDetail.vue?vue&type=script&lang=js"
import style0 from "./BookingPrestaIssueDetail.vue?vue&type=style&index=0&id=cc6e9930&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc6e9930",
  null
  
)

export default component.exports